import createLucideIcon from '../createLucideIcon';

const Copyright = createLucideIcon('Copyright', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M15 9.354a4 4 0 1 0 0 5.292', key: '8xfhbo' }],
]);

export default Copyright;
